// Eligibility check for the BIX/Mutual affinity discount opt-in (#30296).
// Used by both the offer-side (use-discounts) and policy-side (customer/.../discounts.jsx) toggles
// so the two surfaces stay in sync.
//
// A staff user can toggle the discount when:
//   1. the policy is BIX (isBix === true),
//   2. it includes auto, and
//   3. the policy's affinity record carries data.canOptInToBixMutualDiscount === true.
export const isEligibleForBixMutualAffinityDiscount = ({ affinity, affinityLookupsData, isBix, isAuto }) => {
  if (!isBix || !isAuto || !affinity) {
    return false;
  }
  const lookup = affinityLookupsData?.find((aff) => aff.affinity === affinity);
  return lookup?.data?.canOptInToBixMutualDiscount === true;
};
